import core from './core'
import login from './login'
import bridge from './bridge'
import util from './util'
import location from './location'
import pay from './pay'
import system from './system'
import share from './share'
import omega from './omega'
import resapi from './resapi'
import * as loadsdk from './outsdk'

export default {
  // 登录、定位、分享、omega、util，在各端进行统一抹平
  ...login,
  ...util,
  ...share,
  ...location,
  ...system,
  ...omega,
  ...resapi,
  bridge,
  pay,
  // 只有在web上面的方法，收拢到web中
  web: {...core, ...loadsdk}
}
